import ShipmentListCard from '../ShipmentListCard';
import { Package } from 'lucide-react';
import { ShipmentsListProps } from './types';
import { useEffect, useRef } from 'react';

const ShipmentsList = (props: ShipmentsListProps) => {
  const {
    hasNextPage,
    isError,
    isFetchingNextPage,
    items,
    onLoadMore,
    onOpenShipment
  } = props;

  const loaderRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (!hasNextPage || isFetchingNextPage || typeof IntersectionObserver === 'undefined') return;

    const loaderElement = loaderRef.current;

    if (!loaderElement) return;

    const observer = new IntersectionObserver((entries) => {
      if (!entries[0]?.isIntersecting) return;

      onLoadMore();
    }, {
      rootMargin: '240px 0px'
    });

    observer.observe(loaderElement);

    return () => {
      observer.disconnect();
    };
  }, [hasNextPage, isFetchingNextPage, onLoadMore]);

  if (items.length === 0) {
    const emptySubtitle = isError
      ? null
      : 'Передайте файлы от поставщика - мы создадим заявку за вас';
    const emptyTitle = isError ? 'Поставки недоступны' : 'У вас пока нет поставок';

    return (
      <div className="flex flex-col items-center p-8 text-center rounded-lg border border-border bg-card">
        <Package className="mb-3 size-12 text-muted-foreground/30" />
        <p className="mb-1 font-sans text-sm font-medium leading-5 text-foreground">
          {emptyTitle}
        </p>
        {emptySubtitle && (
          <p className="max-w-[240px] font-sans text-xs leading-5 text-muted-foreground">
            {emptySubtitle}
          </p>
        )}
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-6">
      {items.map((item) => (
        <ShipmentListCard
          item={item}
          key={item.id}
          onOpenShipment={onOpenShipment}
        />
      ))}
      {(hasNextPage || isFetchingNextPage) && (
        <div
          className="flex min-h-12 items-center justify-center"
          ref={loaderRef}
        >
          {isFetchingNextPage && (
            <span className="font-sans text-sm leading-5 text-muted-foreground">
              Загрузка еще поставок
            </span>
          )}
        </div>
      )}
    </div>
  );
};

export default ShipmentsList;